<div class="modal-header">
    <h4 class="modal-title fw-bold" id="listTree-heading-modal" jhiTranslate="bmsjHipsterApp.tree-table.title">Open sample list</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="closeModal()">
    </button>
</div>
<div class="modal-body">
    <div class="row mb-3 modal-popover ">
        <div class="col-md-7">
        </div>
        <div class="col-md-5">
            <div class="float-end">
                <img (click)="setMode(Modes.Add, $event)" src="content/images/add2.png" class=""
                     [ngClass]="{ 'disable-image': !selectedNode || selectedNode.data.id === 'CROPLISTS' || selectedNode && selectedNode.leaf }"/>
                <img (click)="setMode(Modes.Rename, $event)" src="content/images/edit.png" class="ps-1"
                     [ngClass]="{ 'disable-image': !selectedNode ||  isRootFolder() || selectedNode && selectedNode.leaf }"/>
                <img (click)="setMode(Modes.Delete, $event)" src="content/images/delete.png" class="ps-1"
                     [ngClass]="{ 'disable-image': !selectedNode ||  isRootFolder() || selectedNode && selectedNode.leaf }"/>
            </div>
        </div>
    </div>
    <div class="row mb-3">
        <div class="col-md-12">
            <div class="form-horizontal mb-3">
                <div id="addFolderDiv" *ngIf="mode == Modes.Add || mode == Modes.Rename">
                    <div class="mb-3 row">
                        <div class="col-9">
                            <div class="input-group">
                                <label class="col-md-2 col-form-label fw-bold">{{ 'common.folder.action.' + Modes[mode].toString().toLowerCase() | translate }}</label>
                                <input type="text" class="form-control col-md-6" placeholder="{{ 'common.folder.name' | translate }}" [(ngModel)]="name" jhi-forbiddenCharactersValidator [required]="true"  maxlength="{{ NAME_MAX_LENGTH }}"/>
                                <button class="btn btn-success" [title]="'common.folder.title.' + Modes[mode].toString().toLowerCase() | translate " [disabled]="containsForbiddenCharacters(name)" (click)="submitAddOrRenameFolder()">
                                    <span class="fa fa-check"></span>
                                </button>
                                <button class="btn btn-danger" title="{{ 'common.form.cancel.text' | translate }}" (click)="mode = Modes.None">
                                    <span class="fa fa-times"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
            <div class="clearfix"></div>
            <div class="mb-3">
                <p-treeTable [value]="nodes"
                             (onNodeExpand)="onNodeExpand($event)"
                             (onRowDblclick)="onRowDblclick($event)"
                             selectionMode="single"
                             [autoLayout]="true"
                             [(selection)]="selectedNode"
                             (onNodeSelect)="onNodeSelect($event)"
                             styleClass="tree-table">
                    <ng-template pTemplate="header">
                        <tr>
                            <th jhiTranslate="bmsjHipsterApp.tree-table.name">Name</th>
                            <th jhiTranslate="bmsjHipsterApp.tree-table.owner">Owner</th>
                            <th jhiTranslate="bmsjHipsterApp.tree-table.description">Description</th>
                            <th jhiTranslate="bmsjHipsterApp.tree-table.type">Type</th>
                            <th jhiTranslate="bmsjHipsterApp.tree-table.entries"># of entries</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-i="rowIndex">
                        <tr [ttSelectableRow]="rowNode">
                            <td>
                                <p-treeTableToggler
                                    [rowNode]="rowNode"
                                ></p-treeTableToggler>
                                <span [ngClass]="{ 'folder': !rowNode.node.leaf, 'file': rowNode.node.leaf }"></span>
                                <span
                                    pDraggable="treedragdrop"
                                    pDroppable="treedragdrop"
                                    (onDragStart)="onDragStart($event, rowNode.node)"
                                    (onDragEnd)="onDragEnd($event, rowNode.node)"
                                    (onDrop)="onDrop($event, rowNode.node)"
                                    (onDragEnter)="onDragEnter($event, rowNode.node)"
                                    (onDragLeave)="onDragLeave($event, rowNode.node)"
                                    data-test="sampleListName"
                                    type="text">
                                        {{translateName(rowData)}}
                                </span>
                            </td>
                            <td>{{rowData.owner}}</td>
                            <td>{{rowData.description}}</td>
                            <td>{{rowData.type}}</td>
                            <td>{{rowData.noOfEntries}}</td>
                        </tr>
                    </ng-template>
                </p-treeTable>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="closeModal()">
        <span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="entity.action.cancel">Cancel</span>
    </button>
    <button type="button" class="btn btn-primary" aria-hidden="true" jhiTranslate="common.form.ok.text" [disabled]="mode != Modes.None || !selectedNode || selectedNode && !selectedNode.leaf"
            (click)="selectList()" data-test="openSampleListOkButton">Ok</button>
</div>
